export default "__VITE_ASSET__d5fa8d15__"